import React from 'react';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

import { HabitInsightsMetricCard } from './habit-insights-metric-card';
import { HabitInsightsPreviewCard } from './habit-insights-preview-card';
import { HabitInsightsCardProps as HabitInsightsCardPropsBase } from './types';

export type HabitInsightsCardProps = HabitInsightsCardPropsBase & {
  skipLimitsCheck?: boolean;
};

export const HabitInsightsCard: React.FC<HabitInsightsCardProps> = ({
  habit,
  skipLimitsCheck,
  ...rest
}) => {
  const { allowed } = usePremiumFeatureAllowed(LimitKeys.Insights, {});

  if (!skipLimitsCheck && !allowed) {
    return <HabitInsightsPreviewCard habit={habit} />;
  }

  return <HabitInsightsMetricCard habit={habit} {...rest} />;
};
